// angular
// 	.module("HeroPRO")
// 	.controller("NotificationModalController", notificationModalController);

import _ from 'lodash';
import './notificationModal.scss';

/* @ngInject */
export default function notificationModalController($scope, $uibModalInstance, NotificationCenterFactory, HPConfig, $window, $rootScope, $analytics, TopNavFactory, authenticationService, UserAuthFactory, $state) {
    const vm = this;

    vm.notifications = [];
    vm.currentTemplate = '';
    vm.canDismissModal = false;
    vm.currentNotification = null;
    vm.toggleClicked = false;
    vm.hisTrainingMandate = {};

    init();
    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

     vm.completeNotification = function (result) {
        NotificationCenterFactory.setActionItemStatus({
            ActionItemId: vm.currentNotification.ActionItemId,
            ActionItemStatus: 3
        })
        .then(() => {
            NotificationCenterFactory.markNotificationComplete(vm.currentNotification.ActionItemId);
            vm.currentNotification.isComplete = true;
            NotificationCenterFactory.markNotificationComplete(vm.currentNotification.ActionItemId);         
            $uibModalInstance.close({ result, errorStatus: null });
            $rootScope.$broadcast('HideMainSpinner');
            window.location.reload();
        })
    };

    vm.closeModal = function (result) {
        $uibModalInstance.close({ result, errorStatus: null });
        $rootScope.$broadcast('HideMainSpinner');
        window.location.reload();
    };

    vm.logout = function () {
        $analytics.eventTrack('Logout', {
            category: 'TopNav',
            label: $state.current.name,
        });

        TopNavFactory.logout().then(() => {
            authenticationService.logOut();
            UserAuthFactory.deleteAuthorization();

            let logoutUrl = HPConfig.heroProLoginLink;

            logoutUrl += '?logout=true';

            $window.location.href = logoutUrl;
        });
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */

    function init() {
        vm.notifications = NotificationCenterFactory.getNotificationData();
        vm.currentNotification = vm.notifications[0];
        NotificationCenterFactory.setActiveNotification(vm.currentNotification);
        vm.canDismissModal = vm.currentNotification.Priority !== 1;
    }
    /* -----  End of Private Functions  ------*/

    /*= ========================================
	 =            Pub/Sub Handlers            =
	 ========================================= */

    $scope.$on('notificationsMenuClick', () => {
	    vm.currentNotification = NotificationCenterFactory.getActiveNotification();
    });

    $scope.$on('notificationCompleted', () => {
		 vm.currentNotification.isComplete = true;
		 NotificationCenterFactory.markNotificationComplete(vm.currentNotification.ActionItemId);
		 vm.currentNotification = NotificationCenterFactory.getActiveNotification();
		 vm.canDismissModal = NotificationCenterFactory.getActiveNotification().Priority !== 1;
    });

    $scope.$on('notificationMenuToggleClick', (evt, data) => {
	    if (data.hasOwnProperty('toggleClicked')) {
	        vm.toggleClicked = data.toggleClicked;
	    }
    });

    $scope.$on('closeNotificationModal', (evt, data) => {
	    data = data || { result: false, errorStatus: null };
	    vm.closeModal(data);
    });

    /* -----  End of Pub/Sub Handlers  ------*/
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/notificationModalController.js